'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FREE = exports.FREE = 'free';
var STARTER = exports.STARTER = 'starter';
var PROFESSIONAL = exports.PROFESSIONAL = 'professional';
var ENTERPRISE = exports.ENTERPRISE = 'enterprise';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/Editions.js
// module id = 29
// module chunks = 3 4 5